import NUM from './NumRegExp'
import CHAR from './CharRegExp'
import SYS from './SysRegExp'
import COMM from './CommonRegExp'

export default {
  NUM, CHAR, COMM, SYS
}
